export const CURRENCY_TRANSLATION_KEYS = {
  multipleLocalCurrencies: 'jbp-partner-currency-multy-local-warning',
} as const
